module.exports = __webpack_public_path__ + "static/img/sev.90d5edb7.png";